import React, { useRef, useEffect, useState } from 'react';
import { CSSTransition } from "react-transition-group";

export const QuizQuestion = ({ question, modules, message, questionIndex, animationType, animationDuration, animationBackgroundColor }) => {
    const refContainer = useRef(null)
    const [open, setOpen] = useState(true)
    useEffect(() => {
        console.log('QUIZ QUESTION EFFECT', questionIndex)
        let wfeEl = refContainer.current.firstChild
        if (!wfeEl || wfeEl.wfeQuestionIndex != questionIndex) {
            if (wfeEl) {
                setOpen(!open)
                refContainer.current.removeChild(wfeEl)
            }
            wfeEl = document.createElement("div")
            wfeEl.className = "webframework-external-package"
            wfeEl.wfeQuestionIndex = questionIndex
            refContainer.current.appendChild(wfeEl)
        }
        modules.realDevice.read(question.question.systemId)
        question.question(modules, null, wfeEl)        
    }, [questionIndex])

    return (
        <>
            <CSSTransition
                in={open}
                timeout={Number(`${animationDuration}`)}
                classNames={animationType}
                onEntering={el => {el.style.backgroundColor = `${animationBackgroundColor}`}}
                onExiting={el => {el.style.backgroundColor = `${animationBackgroundColor}`}}
                onEntered={el => {el.style.backgroundColor = 'transparent'}}
                onExited={el => {el.style.backgroundColor = 'transparent'}}
            >
                <div class={animationType} ref={refContainer} id={`containerId_` + message.systemId + `_subpackageId_` + question.question.systemId}>
                </div>
            </CSSTransition>
        </>
    )
}